import React, { useState } from "react";
import "../styles/Tabs.scss";
import Designs from "./WebDesigns";
import webDesignData from "../data/webDesigns";
import digitalMenuData from "../data/digitalMenus";

function Tabs() {
  const [tab, setTab] = useState("web-designs");

  function handleSelection(e) {
    const tab = e.currentTarget.dataset.tabId;

    setTab(tab);
  }

  return (
    <div className="tab__container">
      <div className="tab__list">
        <li
          onClick={handleSelection}
          className={tab === "web-designs" ? "active__tab" : ""}
          data-tab-id="web-designs"
        >
          WEBSITES
        </li>
        <li
          onClick={handleSelection}
          className={tab === "digital-menu" ? "active__tab" : ""}
          data-tab-id="digital-menu"
        >
          DIGITAL MENUS
        </li>
      </div>
      <div className="tab__content">
        {tab === "web-designs" && (
          <Designs data={webDesignData} tabTitle="Web Designs" />
        )}
        {tab === "digital-menu" && (
          <Designs data={digitalMenuData} tabTitle="Digital Menus" />
        )}
      </div>
    </div>
  );
}

export default Tabs;
